import type { SxProps, Theme } from '@mui/material/styles';
import { actionToolbarSx } from 'components/general';
import { Color } from 'shared/utils/colors';
import {
  issueCodeNavGroupSx,
  issueNavigationClusterSx,
  issueViewHeaderSx,
} from '../IssueViewHeader/styles';

export const issueViewHeaderSkeletonBoneSx: SxProps<Theme> = {
  transform: 'none',
  bgcolor: Color.scrimBlack07,
};

export const issueViewHeaderSkeletonBoneSubtleSx: SxProps<Theme> = {
  transform: 'none',
  bgcolor: Color.solidGrayRing90,
};

export const issueViewHeaderSkeletonNavButtonSx: SxProps<Theme> = {
  ...issueViewHeaderSkeletonBoneSubtleSx,
  flexShrink: 0,
};

export const issueViewHeaderSkeletonProcessTileSx: SxProps<Theme> = {
  ...issueViewHeaderSkeletonBoneSubtleSx,
  borderRadius: '20px',
  flexShrink: 0,
};

export const issueViewHeaderSkeletonCodeSx: SxProps<Theme> = {
  ...issueViewHeaderSkeletonBoneSx,
  borderRadius: 0.5,
  flexShrink: 1,
  minWidth: 0,
  maxWidth: '100%',
};

/**
 * Same chrome as loaded header. `minHeight` = `py: 2` (32px) + 48px nav IconButtons.
 */
export const issueViewHeaderSkeletonRootSx: SxProps<Theme> = {
  ...issueViewHeaderSx,
  minHeight: 80,
  boxSizing: 'border-box',
};

/** `ProcessIconSize.small` */
export const issueViewHeaderSkeletonProcessTileWidth = 33;
export const issueViewHeaderSkeletonProcessTileHeight = 19;

/** MUI `IconButton` `size='large'` in `ButtonIcon` / nav cluster. */
export const issueViewHeaderSkeletonNavButtonSize = 48;

/** `ButtonTextIcon` row inside `actionToolbarSx`. */
export const issueViewHeaderSkeletonToolbarHeight = 40;

export const issueViewHeaderSkeletonToolbarSegmentHeight = 20;

/** `ButtonTextIcon` start icon at 1rem label line box. */
export const issueViewHeaderSkeletonToolbarIconSize = 20;

/** `issueCodeNavTypographySx` line box (~0.9375rem × 1.25). */
export const issueViewHeaderSkeletonCodeHeight = 19;

export const issueViewHeaderSkeletonNavSx = issueNavigationClusterSx;

export const issueViewHeaderSkeletonCodeGroupSx = issueCodeNavGroupSx;

export const issueViewHeaderSkeletonActionsSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'center',
  marginLeft: 'auto',
  flexShrink: 0,
};

export const issueViewHeaderSkeletonToolbarSx: SxProps<Theme> = {
  ...actionToolbarSx,
  display: 'inline-flex',
  alignItems: 'center',
  height: issueViewHeaderSkeletonToolbarHeight,
  minHeight: issueViewHeaderSkeletonToolbarHeight,
  px: 0.5,
};

export const issueViewHeaderSkeletonToolbarBoneSx: SxProps<Theme> = {
  ...issueViewHeaderSkeletonBoneSubtleSx,
  borderRadius: 0.5,
  flexShrink: 0,
};

/** One toolbar cell: padding + icon + gap + label, like `ButtonTextIcon`. */
export const issueViewHeaderSkeletonToolbarButtonSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  px: 1.5,
  flexShrink: 0,
  alignSelf: 'center',
  boxSizing: 'border-box',
};
